import { render, staticRenderFns } from "./PasswordHistory.vue?vue&type=template&id=d2eba50e&scoped=true&"
import script from "./PasswordHistory.vue?vue&type=script&lang=js&"
export * from "./PasswordHistory.vue?vue&type=script&lang=js&"
import style0 from "./PasswordHistory.vue?vue&type=style&index=0&id=d2eba50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eba50e",
  null
  
)

export default component.exports